<div class="sc-checkbox" (click)="handleClick()">
    <input class="sc-checkbox__input" type="checkbox" [checked]="value" [disabled]="isDisabled" [readonly]="isReadOnly" [id]="id" />
    <div [ngClass]="squareClasses"></div>
    <label class="sc-checkbox__label" [class.disabled]="isDisabled || isReadOnly">
        <ng-content></ng-content>
    </label>
</div>